import { createContext } from 'react';
import type { MessageGenSession, MessageGenState, CreateMessageGenSessionRequest } from '@trinity/chat';

export type MessageGenerationDispatch = (state: MessageGenState) => void;
export type MessageGenerationCreateSession = (
  sessionId: string,
  initialState?: CreateMessageGenSessionRequest['initialState']
) => void;
export type MessageGenerationLoadSession = (messageGenSessionId: number) => void;

export const MessageGenerationStateContext = createContext<MessageGenSession | null>(null);
MessageGenerationStateContext.displayName = 'MessageGenerationStateContext';

export const MessageGenerationDispatchContext = createContext<MessageGenerationDispatch | null>(null);
MessageGenerationDispatchContext.displayName = 'MessageGenerationDispatchContext';

export const MessageGenerationCreateSessionContext = createContext<MessageGenerationCreateSession | null>(
  null
);
MessageGenerationCreateSessionContext.displayName = 'MessageGenerationCreateSessionContext';

export const MessageGenerationLoadSessionContext = createContext<MessageGenerationLoadSession | null>(null);
MessageGenerationLoadSessionContext.displayName = 'MessageGenerationLoadSessionContext';
